import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/blog/_components/blog-card-set/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/vercel/path0/apps/www/app/[locale]/(site)/blog/_components/blog-card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Bio"] */ "/vercel/path0/apps/www/app/[locale]/(site)/blog/authors/[author]/_components/bio/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/blog/authors/[author]/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/localized-translation-toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/packages/mds-react/dist/components/card/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/flight-icon/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerCard"] */ "/vercel/path0/packages/mds-react/dist/patterns/card/partner-card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Thumbnail","PersonThumbnail","LogoThumbnail"] */ "/vercel/path0/packages/mds-react/dist/patterns/card/thumbnails/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/packages/mds-react/dist/patterns/copy-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedContent"] */ "/vercel/path0/packages/mds-react/dist/patterns/related-content/index.js");
